var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRecap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315 315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    className: "cls-1",
    d: "M146.3,168.74l-33.87-2.87-78.51-6.56c-7.05-.59-14.09-1.26-21.14-1.74-6.07,.16-11.38-4.05-12.6-10-.99-5.97,2.48-11.77,8.21-13.73L170.02,59.84C212.2,40.54,254.39,21.24,296.58,1.93c5.56-3.6,12.99-2.03,16.6,3.52,.85,1.31,1.44,2.77,1.73,4.31,.33,3.22-.24,6.47-1.65,9.39-14.62,32.24-29.43,64.39-44.19,96.56l-87.19,189.94c-3.11,6.8-7.42,9.82-13.18,9.28-5.91-.55-10.56-5.29-10.98-11.2-1.59-18.47-3.09-36.93-4.63-55.39-2.1-25.26-4.2-50.52-6.3-75.77,.01-1.13-.21-2.27-.49-3.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRecap);
export default __webpack_public_path__ + "static/media/map_recap.53ccd5549168e128ed1624339000728d.svg";
export { ForwardRef as ReactComponent };